<template>
    <div v-if="showCategoryAdmin">
        <label class="titlelabel">Ecommerce Categories</label>
        <smallbutton @click="getCategories()" toplabel="Refresh" buttonclass="button buttonprimary left10"/>
        <smallbutton @click="openCreate()" toplabel="New Category" buttonclass="button buttonsave left10"/>

        <div class="bordered" v-if="categoryList.length > 0">
            <div class="horizFlex categoryHeaderRow bold">
                <div class="colName">Name</div>
                <div class="colOrder">Order</div>
                <div class="colFlag">Visible</div>
                <div class="colFlag">Featured</div>
                <div class="colFlag">Guest</div>
                <div class="colFlag">Auth Req</div>
                <div class="colEdit"></div>
            </div>
            <div class="horizFlex categoryRow" v-for="cat in categoryList" :key="cat.ecommerceCategoryId">
                <div class="colName">{{cat.categoryName}}</div>
                <div class="colOrder">{{cat.displayOrder}}</div>
                <div class="colFlag">{{cat.isVisible ? '✓' : ''}}</div>
                <div class="colFlag">{{cat.isFeatured ? '✓' : ''}}</div>
                <div class="colFlag">{{cat.guestVisible ? '✓' : ''}}</div>
                <div class="colFlag">{{cat.requiresAuthentication ? '✓' : ''}}</div>
                <div class="colEdit horizFlex">
                    <pencilbutton @click="startUpdate(cat)"/>
                    <span class="catmove" role="button" tabindex="0" aria-label="Move up" title="Move up" @click="moveCategory(cat,'up')" @keydown.enter.prevent="moveCategory(cat,'up')" @keydown.space.prevent="moveCategory(cat,'up')">▲</span>
                    <span class="catmove" role="button" tabindex="0" aria-label="Move down" title="Move down" @click="moveCategory(cat,'down')" @keydown.enter.prevent="moveCategory(cat,'down')" @keydown.space.prevent="moveCategory(cat,'down')">▼</span>
                    <span class="catdelete" role="button" tabindex="0" aria-label="Delete category" title="Delete" @click="deleteCategory(cat)" @keydown.enter.prevent="deleteCategory(cat)" @keydown.space.prevent="deleteCategory(cat)">🗑</span>
                </div>
            </div>
        </div>
        <p v-else class="messagetext">{{listMessage}}</p>

        <!-- EDIT CATEGORY MODAL -->
        <actionmodal ref="mymodal">
            <template v-slot:body>
                <form ref="myform" @submit.prevent>
                    <label class="titlelabel">Edit Category — {{editCategory.categoryName}}</label>

                    <formentry inputid="catnamefield" label="Display Name" v-model="editCategory.categoryName"/>
                    <formentry inputid="catorderfield" label="Display Order" v-model="editCategory.displayOrder"/>
                    <formentry inputid="catshortfield" label="Short Description" v-model="editCategory.shortDescription"/>
                    <formentry inputid="catdescfield" label="Description" v-model="editCategory.description"/>
                    <formentry inputid="catimagefield" label="Image Filename" v-model="editCategory.imageFilename"/>
                    <formentry inputid="caticonfield" label="Icon Class" v-model="editCategory.iconClass"/>
                    <formentry inputid="catbgfield" label="Background Color" v-model="editCategory.backgroundColor"/>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="catvisiblefield" title="Show or hide this category on the storefront.">Visible</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="catvisiblefield" class="entryCheckbox" type="checkbox" v-model="editCategory.isVisible">
                        </div>
                    </div>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="catfeaturedfield" title="Highlight this category on the storefront homepage.">Featured</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="catfeaturedfield" class="entryCheckbox" type="checkbox" v-model="editCategory.isFeatured">
                        </div>
                    </div>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="catguestfield" title="Allow non-logged-in shoppers (guests) to see this category.">Guest Visible</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="catguestfield" class="entryCheckbox" type="checkbox" v-model="editCategory.guestVisible">
                        </div>
                    </div>

                    <div class="entry">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="catauthfield" title="Require login to view this category — hides it from guests (e.g. Course Materials).">Requires Authentication</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="catauthfield" class="entryCheckbox" type="checkbox" v-model="editCategory.requiresAuthentication">
                        </div>
                    </div>

                    <hr/>
                    <label class="entryLabel">Category Images</label>
                    <div class="horizFlex" style="flex-wrap:wrap;">
                        <div v-for="img in categoryImages" :key="img.categoryImageId" class="ecomImageCard">
                            <img :src="ecomCatImageUrl(img)" class="ecomImageThumb" alt="category image"/>
                            <div class="ecomImagePrimary" v-if="img.isPrimary">★ Primary</div>
                            <div class="vertFlex">
                                <smallbutton v-if="!img.isPrimary" toplabel="Set as Primary" buttonclass="button buttonsave imgcardbtn" @click="setCategoryImagePrimary(img)"/>
                                <smallbutton toplabel="Delete" buttonclass="button buttoncancel imgcardbtn" @click="deleteCategoryImage(img)"/>
                            </div>
                        </div>
                        <div v-if="categoryImages.length==0" class="messagetext">No images yet.</div>
                    </div>
                    <div class="horizFlex" style="margin-top:8px;align-items:center;">
                        <input type="file" accept="image/*" ref="ecomCatFileInput" @change="onEcomCatFile"/>
                        <smallbutton class="left10" toplabel="Upload" @click="uploadCategoryImage"/>
                    </div>
                    <label class="messagetext">{{ ecomCatImageMsg }}</label>
                    <hr/>

                    <smallbutton @click="saveCategory()" toplabel="Save" buttonclass="button buttonsave"/>
                    <smallbutton @click="cancelupdate()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                    <div>
                        <label class="responsemessage">{{message}}</label>
                    </div>
                </form>
            </template>
        </actionmodal>

        <!-- CREATE CATEGORY MODAL -->
        <actionmodal ref="createmodal">
            <template v-slot:body>
                <form ref="createform" @submit.prevent>
                    <label class="titlelabel">New Ecommerce Category</label>
                    <div class="entry">
                        <div class="entryTextDiv"><label class="entryLabel" for="newcatpc">Product Category</label></div>
                        <div class="entryTextDiv">
                            <select id="newcatpc" v-model="newCategory.productCategoryID" @change="onSelectProductCategory" style="min-width:220px;padding:4px;">
                                <option :value="null" disabled>-- Select a category --</option>
                                <option v-for="pc in productCategoryList" :key="pc.productCategoryID" :value="pc.productCategoryID">{{pc.name}}</option>
                            </select>
                        </div>
                    </div>
                    <formentry inputid="newcatslug" label="Category Slug" v-model="newCategory.categorySlug"/>
                    <formentry inputid="newcatname" label="Display Name" v-model="newCategory.displayName"/>
                    <formentry inputid="newcatshort" label="Short Description" v-model="newCategory.shortDescription"/>
                    <formentry inputid="newcatdesc" label="Description" v-model="newCategory.description"/>
                    <formentry inputid="newcatorder" label="Display Order" v-model="newCategory.displayOrder"/>
                    <div class="entry">
                        <div class="entryTextDiv"><label class="entryLabel" for="newcatvisible">Visible</label></div>
                        <div class="entryTextDiv"><input id="newcatvisible" class="entryCheckbox" type="checkbox" v-model="newCategory.isVisible"></div>
                    </div>
                    <div class="entry">
                        <div class="entryTextDiv"><label class="entryLabel" for="newcatfeatured">Featured (show online)</label></div>
                        <div class="entryTextDiv"><input id="newcatfeatured" class="entryCheckbox" type="checkbox" v-model="newCategory.isFeatured"></div>
                    </div>
                    <smallbutton @click="saveNewCategory()" toplabel="Create" buttonclass="button buttonsave"/>
                    <smallbutton @click="$refs.createmodal.closeModal()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                    <div><label class="responsemessage">{{message}}</label></div>
                </form>
            </template>
        </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../actions/actionmodal.vue'
import formentry from '../controls/entry.vue'
import pencilbutton from '../controls/pencilbutton.vue'
export default {
    name:'categoryadmin',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        pencilbutton
    },
    mixins:[datamethods],
    data(){
        return{
            categoryList:[],
            editCategory:{},
            message:'',
            listMessage:'No categories loaded.',
            categoryImages:[],
            ecomCatFile:null,
            ecomCatImageMsg:'',
            newCategory:{},
            productCategoryList:[]
        }
    },
    computed:{
        ...mapFields([
            'pleaseWait'
        ]),
        showCategoryAdmin(){
            return !!window.ECOM_CATEGORY_ADMIN
        }
    },
    methods:{
        async getCategories(){
            this.$store.dispatch('beforeAPI')
            // visibleOnly=false so hidden categories are included for admin editing
            var response = await this.callAPI_Get('ecommerce/categories/db?visibleOnly=false')
            if(response.Successful){
                this.categoryList = response.categories || []
                if(this.categoryList.length === 0){ this.listMessage = 'No categories found.' }
            }else{
                this.listMessage = response.Message
            }
            this.pleaseWait=false
        },
        startUpdate(cat){
            // clone so cancel discards edits
            this.editCategory = JSON.parse(JSON.stringify(cat))
            this.message=''
            this.categoryImages=[]
            this.ecomCatImageMsg=''
            this.getCategoryImages()
            this.$refs.mymodal.openModal()
        },
        async deleteCategory(cat){
            if(!confirm('Delete category "'+cat.categoryName+'"?')){return}
            this.$store.dispatch('beforeAPI')
            var response = await this.callAPI_Delete('ecommerce/category/ecommerce/'+cat.ecommerceCategoryId)
            this.pleaseWait=false
            if(response.Successful){this.getCategories()}
            else{this.listMessage = response.Message}
        },
        // Map a category list row to an UpdateEcommerceCategoryRequest with a given order.
        catToReq(cat, displayOrder){
            return {
                CategorySlug:cat.categorySlug, DisplayName:cat.categoryName, Description:cat.description,
                ShortDescription:cat.shortDescription, DisplayOrder:displayOrder, IsVisible:cat.isVisible,
                IsFeatured:cat.isFeatured, ImageFilename:cat.imageFilename, IconClass:cat.iconClass,
                BackgroundColor:cat.backgroundColor, RequiresAuthentication:cat.requiresAuthentication,
                GuestVisible:cat.guestVisible
            }
        },
        async moveCategory(cat, dir){
            var list = this.categoryList
            var i = list.findIndex(c=>c.ecommerceCategoryId===cat.ecommerceCategoryId)
            var j = dir==='up' ? i-1 : i+1
            if(j<0 || j>=list.length){return}
            var a = list[i], b = list[j]
            // Swap display orders via the working category-update route (equal orders -> use positions).
            var aOrder = a.displayOrder, bOrder = b.displayOrder
            if(aOrder === bOrder){ aOrder = i; bOrder = j }
            this.$store.dispatch('beforeAPI')
            var r1 = await this.callAPI_Put('ecommerce/category/ecommerce/'+a.ecommerceCategoryId, this.catToReq(a, bOrder))
            var r2 = await this.callAPI_Put('ecommerce/category/ecommerce/'+b.ecommerceCategoryId, this.catToReq(b, aOrder))
            this.pleaseWait=false
            if(r1.Successful && r2.Successful){this.getCategories()}
            else{this.listMessage = (r1.Message||r2.Message)}
        },
        openCreate(){
            this.newCategory = {productCategoryID:null, categorySlug:'', displayName:'', description:'', shortDescription:'', displayOrder:0, isVisible:true, isFeatured:false}
            this.message=''
            this.getProductCategories()
            this.$refs.createmodal.openModal()
        },
        async getProductCategories(){
            var response = await this.callAPI(null,'ecommerce/admin/productcategories')
            if(response.Successful){ this.productCategoryList = response.productCategories || [] }
            else { this.message = response.Message }
        },
        onSelectProductCategory(){
            // Auto-fill display name + slug from the chosen category (both still editable)
            var pc = this.productCategoryList.find(c => c.productCategoryID == this.newCategory.productCategoryID)
            if(pc){
                if(!this.newCategory.displayName){ this.newCategory.displayName = pc.name }
                if(!this.newCategory.categorySlug){ this.newCategory.categorySlug = pc.name.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'') }
            }
        },
        async saveNewCategory(){
            if(!this.newCategory.productCategoryID || !this.newCategory.categorySlug){this.message='Please select a product category and enter a slug';return}
            this.$store.dispatch('beforeAPI')
            var response = await this.callAPI(this.newCategory, 'ecommerce/admin/category/create')
            this.pleaseWait=false
            if(response.Successful){this.$refs.createmodal.closeModal();this.getCategories()}
            else{this.message = response.Message}
        },
        // ---- Category images (Cloudflare via X-API-Key) ----
        // Bullet-proofed: clean CF name (category-<id>[.ext]) -> <prefix>-<base>; a raw/legacy name
        // or missing name falls back to the stable <prefix>-category-<categoryId> convention, so a
        // stray filename never produces a broken imagedelivery.net/<hash>/<raw name>/thumb url.
        ecomCatImageUrl(img){
            if(!img){return ''}
            var hash = window.VUE_APP_CF_IMAGES_ACCOUNT_HASH
            var prefix = window.CF_IMAGE_PREFIX || ''
            if(!hash){return ''}
            var fileName = (typeof img === 'string') ? img : img.fileName
            var catId = (typeof img === 'object' && img.categoryId) ? img.categoryId
                        : (this.editCategory && this.editCategory.categoryId)
            var id = ''
            if(fileName){
                var base = String(fileName).trim().replace(/\.(png|jpg|jpeg|gif|webp)$/i,'')
                if(/^category-/.test(base)){ id = prefix ? (prefix+'-'+base) : base }
            }
            if(!id && catId){ id = (prefix ? prefix+'-' : '') + 'category-' + catId }
            if(!id){return ''}
            return 'https://imagedelivery.net/'+hash+'/'+encodeURIComponent(id)+'/thumb'
        },
        async getCategoryImages(){
            if(!this.editCategory || !this.editCategory.categoryId){this.categoryImages=[];return}
            var response = await this.callAPI_Get('ecommerce/category/'+this.editCategory.categoryId+'/images')
            if(response.Successful){this.categoryImages = response.images || []}
        },
        onEcomCatFile(e){
            var f = e.target.files[0]
            var v = this.validateImageFile(f)
            if(!v.ok){ this.ecomCatImageMsg = v.message; this.ecomCatFile = null; if(this.$refs.ecomCatFileInput){this.$refs.ecomCatFileInput.value=''}; return }
            this.ecomCatImageMsg = ''
            this.ecomCatFile = f
        },
        async uploadCategoryImage(){
            if(!this.ecomCatFile){this.ecomCatImageMsg='Choose a file';return}
            var fd = new FormData()
            fd.append('file', this.ecomCatFile)
            fd.append('setAsPrimary','true')
            this.$store.dispatch('beforeAPI')
            var response = await this.callAPI_Upload('ecommerce/category/'+this.editCategory.categoryId+'/image', fd)
            this.pleaseWait=false
            if(response.Successful){
                this.ecomCatFile=null
                if(this.$refs.ecomCatFileInput){this.$refs.ecomCatFileInput.value=''}
                // reflect the new primary as the category's displayed image and persist it
                this.editCategory.imageFilename = response.fileName
                await this.persistCategoryImage()
                this.ecomCatImageMsg='Uploaded & set as the category image'
                this.getCategoryImages()
            }else{this.ecomCatImageMsg = response.Message || 'Upload failed'}
        },
        async setCategoryImagePrimary(img){
            this.$store.dispatch('beforeAPI')
            var response = await this.callAPI_Put('ecommerce/categoryimage/'+img.categoryImageId+'/primary', {})
            this.pleaseWait=false
            if(response.Successful){this.editCategory.imageFilename = img.fileName; await this.persistCategoryImage(); this.ecomCatImageMsg='Primary set & saved'; this.getCategoryImages()}
            else{this.ecomCatImageMsg = response.Message || 'Failed to set primary image'}
        },
        async deleteCategoryImage(img){
            if(!confirm('Delete this image?')){return}
            this.$store.dispatch('beforeAPI')
            var response = await this.callAPI_Delete('ecommerce/categoryimage/'+img.categoryImageId)
            this.pleaseWait=false
            if(response.Successful){this.getCategoryImages()}
            else{this.ecomCatImageMsg = response.Message || 'Failed to delete image'}
        },
        cancelupdate(){
            this.$refs.mymodal.closeModal()
        },
        // Map the display model back to UpdateEcommerceCategoryRequest (PascalCase, PUT).
        buildCategoryReq(){
            return {
                CategorySlug:this.editCategory.categorySlug,
                DisplayName:this.editCategory.categoryName,
                Description:this.editCategory.description,
                ShortDescription:this.editCategory.shortDescription,
                DisplayOrder:parseInt(this.editCategory.displayOrder),
                IsVisible:this.editCategory.isVisible,
                IsFeatured:this.editCategory.isFeatured,
                ImageFilename:this.editCategory.imageFilename,
                IconClass:this.editCategory.iconClass,
                BackgroundColor:this.editCategory.backgroundColor,
                RequiresAuthentication:this.editCategory.requiresAuthentication,
                GuestVisible:this.editCategory.guestVisible
            }
        },
        async saveCategory(){
            this.$store.dispatch('beforeAPI')
            var response = await this.callAPI_Put('ecommerce/category/ecommerce/' + this.editCategory.ecommerceCategoryId, this.buildCategoryReq())
            this.pleaseWait=false
            if(!response.Successful){
                this.message = response.Message
                return
            }
            this.$refs.mymodal.closeModal()
            this.getCategories()
        },
        // Persist the (image) change without closing the modal — sends all fields to avoid wiping.
        async persistCategoryImage(){
            var response = await this.callAPI_Put('ecommerce/category/ecommerce/' + this.editCategory.ecommerceCategoryId, this.buildCategoryReq())
            if(response.Successful){ this.getCategories() }
        }
    },
    mounted(){
        this.getCategories()
    }
}
</script>

<style scoped>
.categoryHeaderRow{
    border-bottom:1px solid var(--frame-color);
    padding:5px 0px;
}
.categoryRow{
    padding:5px 0px;
    align-items:center;
}
.colName{ width:280px; }
.colOrder{ width:70px; }
.colFlag{ width:90px; text-align:center; }
.colEdit{ width:130px; }
.catmove, .catdelete{ cursor:pointer; margin-left:8px; }
.catdelete{ color:#c11d1d; }
.ecomImageCard{
    border:1px solid #ccc; border-radius:5px; padding:6px; margin:6px; width:120px; text-align:center;
}
.ecomImageThumb{
    width:100px; height:100px; object-fit:cover; border-radius:4px; background:#f0f0f0;
}
.ecomImagePrimary{ color:var(--success-color,#699864); font-weight:bold; font-size:small; }
.imgcardbtn{
    width:104px !important; height:26px !important; margin:3px 0px !important;
    font-size:12px !important; border-radius:6px !important;
}
.imgcardbtn .buttontext{ font-size:12px !important; }
</style>
